export default class MathExtension {
    static sum(array) {
        return array.reduce((pv, cv) => pv + cv, 0);
    }
}
